import type { ExchangeRate, ExchangeStatus } from '@/services/exchange/types'
import { company } from '@/config/company'
import { currencyFlag } from '@/utils/currencyFlag'
import { formatRate } from '@/utils/formatRate'
import styles from './RateCards.module.css'

interface RateCardsProps {
  rates: ExchangeRate[]
  status: ExchangeStatus
  error: string | null
  lastSuccessAt?: Date | null
}

export function RateCards({ rates, status, error, lastSuccessAt }: RateCardsProps) {
  const updated =
    lastSuccessAt &&
    lastSuccessAt.toLocaleString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.heading}>
          <h1 className={styles.brand}>{company.name}</h1>
          <p className={styles.legal}>{company.legalName}</p>
          {updated ? (
            <p className={styles.updated}>
              Son Güncelleme <time dateTime={lastSuccessAt!.toISOString()}>{updated}</time>
            </p>
          ) : null}
        </div>

        {(status === 'error' || status === 'loading') && rates.length === 0 && (
          <p className={styles.status}>
            {status === 'loading' ? 'Kurlar yükleniyor…' : error || 'Kurlar geçici olarak alınamıyor.'}
          </p>
        )}

        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th scope="col">Sembol</th>
                <th scope="col">Cinsi</th>
                <th scope="col">Alış</th>
                <th scope="col">Satış</th>
              </tr>
            </thead>
            <tbody>
              {rates.map((rate) => (
                <tr key={rate.sourceCode}>
                  <td>
                    <span className={styles.flag} aria-hidden>
                      {currencyFlag(rate.code)}
                    </span>
                  </td>
                  <td>
                    <strong>{rate.name}</strong>
                    <span className={styles.code}>
                      {rate.code}
                      /TRY
                    </span>
                  </td>
                  <td className={styles.num}>{formatRate(rate.buy)}</td>
                  <td className={styles.numSell}>{formatRate(rate.sell)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
